import React from 'react';
import PageLayout from '../components/ui/PageLayout';
import PageHeaderActionsBar from '../components/ui/PageHeaderActionsBar';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <PageLayout>
      <PageHeaderActionsBar
        title="Page Not Found"
        description="The page you're looking for doesn't exist."
        primaryAction={{ label: 'Back to Dashboard', onClick: () => navigate('/dashboard') }}
      />
    </PageLayout>
  );
}
